<template>
    <div class="apprentice-simple-card">
        <div class="magazine-check">
            <div class="magazine-check-header">
                <h2 class="title">{{ magazine.title }}</h2>
                <div class="actions">
                    <b-button
                        class="btn-decline-magazine"
                        v-if="magazine.checked == 1 && magazine.status[0].status == $t('magazine.agree')"
                        variant="danger"
                        @click="onDisapprove">
                        {{ $t('magazine.disapprove') }}
                    </b-button>

                    <b-button
                        class="btn-approve-magazine"
                        v-else="magazine.checked == 0"
                        variant="success"
                        @click="onApprove">
                        {{ $t('magazine.approve') }}
                    </b-button>

                    <b-button
                        class="btn-show-magazine"
                        v-if="magazine.pdf_inner"
                        variant="primary"
                        :href="magazine.pdf_inner">
                        Highres pdf
                    </b-button>

                    <b-button
                        class="btn-show-magazine-cover"
                        v-if="magazine.pdf_cover"
                        variant="primary"
                        :href="magazine.pdf_cover">
                        Highres cover pdf
                    </b-button>
                </div>
            </div>

            <div class="magazine-check-content">
                <div class="additional-info">
                    <h3 class="title">{{ $t('magazine.information') }}</h3>
                    <b-list-group class="magazine-info">
                        <b-list-group-item class="magazine-info-item">
                            <span class="label">school id:</span>
                            <span class="magazine-school-id">
                                {{ magazine.school_id }}
                            </span>
                        </b-list-group-item>
                        <b-list-group-item class="magazine-info-item">
                            <span class="label">{{ $t('magazine.yearbook_id') }}:</span>
                            <span class="magazine-school-id">
                                {{ magazine.id }}
                            </span>
                        </b-list-group-item>
                        <b-list-group-item class="magazine-info-item">
                            <span class="label">{{ $t('magazine.yearbook_version') }}:</span>
                            <span class="magazine-school-id">
                                {{ magazine.version }}
                            </span>
                        </b-list-group-item>
                        <b-list-group-item class="magazine-info-item">
                            <span class="label">{{ $t('magazine.amount_of_pages') }}:</span>
                            <span class="magazine-school-id">
                                {{ magazine.num_pages }}
                            </span>
                        </b-list-group-item>
                    </b-list-group>
                </div>

                <div
                    class="logs"
                    v-if="magazine.status.length > 0">
                    <h3 class="title">{{ $t('magazine.logbook') }}</h3>

                    <b-list-group class="magazine-log">
                        <b-list-group-item
                            class="magazine-log-item"
                            v-for="status in magazine.status"
                            :key="status.id">
                            <div class="date">
                                <div class="label">{{ $t('magazine.date') }}:</div>
                                <span class="logged-date"
                                    >{{ moment(status.shortdate).format('DD MMM') }} {{ status.shorttime }}</span
                                >
                            </div>

                            <div class="user">
                                <div class="label">{{ $t('magazine.user') }}</div>
                                <span
                                    class="logged-user"
                                    v-if="status.user">
                                    {{ status.user.full_name }}
                                </span>
                                <span
                                    class="logged-user"
                                    v-else>
                                    Portal
                                </span>
                            </div>

                            <div class="status">
                                <div class="label">Status:</div>
                                <span class="logged-status">
                                    {{ status.status }}
                                </span>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </div>

            <div class="magazine-check-pages-check">
                <design2021-magazine-check-page-component
                    v-for="(page, index) in pages"
                    v-if="shouldDisplayPage(page, index)"
                    :ref="`page-check-${page.order}`"
                    :highres-image="page.highres"
                    :lowres-image="page.lowres"
                    :page-order="page.order"
                    :page-index="index"
                    :magazine-type="magazine.version"
                    :observer="observer"
                    :key="page.id">
                </design2021-magazine-check-page-component>
            </div>
        </div>
    </div>
</template>

<script>
import Design2021ApprenticeInlineSvgComponent from '../common/design-2021-apprentice-inline-svg-component.vue';

export default {
    name: 'MagazineCheckComponent',
    components: { Design2021ApprenticeInlineSvgComponent },
    props: ['magazine', 'deadlineId'],
    data() {
        return {
            observer: null,
            currentPageOrder: 0,
        };
    },

    mounted() {
        window.addEventListener('keyup', this.keyPress);
        this.observer = new IntersectionObserver(
            (entries) => {
                for (const entry of entries) {
                    if (entry.intersectionRatio > 0) {
                        this.currentPageOrder = parseInt(entry.target.getAttribute('id').split('-').slice(-1)[0]);
                    }
                }
            },
            {
                rootMargin: '0px 0px -90% 0px',
            },
        );

        document.querySelectorAll('.magazine-check-pages-check .magazine-page-check').forEach((page) => {
            this.observer.observe(page);
        });
    },

    methods: {
        onApprove() {
            this.alert
                .confirm(
                    this.$t('magazine.approve'),
                    this.$t('magazine.are_you_sure_you_want_to_approve_this_product'),
                    this.$t('magazine.approve'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        var data = {
                            checked: 1,
                        };

                        this.axios.post(this.routes.magazineCheckApprove(this.magazine.id), data).then(
                            (response) => {
                                this.alert.success();

                                window.location.href = this.routes.magazineYearbookList() + '/' + this.deadlineId;
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },

        onDisapprove() {
            this.alert
                .confirm('Afkeuren', 'Weet je zeker dat je dit product wil afkeuren?', 'Afkeuren')
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        var data = {
                            checked: 0,
                        };

                        this.axios.post(this.routes.magazineCheckApprove(this.magazine.id), data).then(
                            (response) => {
                                this.alert.success();
                                window.location.href = this.routes.magazineYearbookList() + '/' + this.deadlineId;
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },

        keyPress(keyEv) {
            if (keyEv.keyCode === 40) {
                this.navigateNextPage();
            } else if (keyEv.keyCode === 38) {
                this.navigatePreviousPage();
            }
        },

        navigateNextPage() {
            const max = this.pages.length;
            this.currentPageOrder =
                this.currentPageOrder === 0
                    ? 1
                    : this.currentPageOrder + 1 > max
                      ? this.currentPageOrder
                      : this.currentPageOrder + 1;
            const page = `page-check-${this.currentPageOrder}`;
            if (this.$refs[page]) {
                const el = document.getElementById(`page-order-${this.currentPageOrder}`);
                el.scrollIntoView();
            }
        },

        navigatePreviousPage() {
            this.currentPageOrder = this.currentPageOrder === 1 ? 1 : this.currentPageOrder;
            const page = `page-check-${this.currentPageOrder}`;
            if (this.$refs[page]) {
                const el = document.getElementById(`page-order-${this.currentPageOrder}`);
                el.scrollIntoView();
            }
        },

        shouldDisplayPage(page, index) {
            if (
                this.magazine.version.toLowerCase() !== 'garenloos' &&
                this.magazine.version.toLowerCase() !== 'hardbound'
            ) {
                return true;
            } else if ((index === 1 || index === this.pages.length - 2) && page.highres === '' && page.lowres === '') {
                return false;
            }

            return true;
        },
    },

    computed: {
        pages() {
            if (this.magazine.pages.length === 0) {
                return [];
            }

            return this.magazine.pages.map((page) => {
                if (page.highres === null) {
                    page.highres = '';
                }

                if (page.lowres === null) {
                    page.lowres = '';
                }

                return page;
            });
        },
    },

    beforeDestroy() {
        this.observer.disconnect();
        window.removeEventListener('keyup', this.keyPress);
    },
};
</script>

<style scoped lang="scss">
.btn-approve-magazine {
    color: $white;
}

.magazine-check-header,
.magazine-check-content {
    display: flex;
    flex-direction: column;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.magazine-check-header {
    row-gap: map-get($grid-gutter-spacing, 'ten');

    .title {
        margin-bottom: 0;
    }

    .actions {
        align-self: flex-end;
        width: 100%;

        .btn {
            width: inherit;

            &:not(:last-child) {
                margin-bottom: map-get($grid-gutter-spacing, 'ten');
            }
        }
    }
}

.magazine-check-content {
    color: $text-muted-color;
    font-weight: $font-weight-medium;

    .title,
    .label {
        color: $text-color;
    }

    .label {
        display: inline-block;
        margin-bottom: 0;
    }

    .list-group-item {
        border: none;
        padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');

        &:nth-child(odd) {
            background-color: $secondary-background-color;
        }
    }
}

.magazine-info {
    margin-bottom: $grid-gutter-width;

    .label {
        width: 115px;
    }
}

.magazine-log {
    max-height: 350px;
    overflow-y: auto;
}

.logs {
    .label {
        width: 90px;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .magazine-check-header {
        .actions {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            column-gap: map-get($grid-gutter-spacing, 'fifteen');

            .btn {
                width: auto;

                &:not(:last-child) {
                    margin-bottom: 0;
                }
            }
        }
    }

    .magazine-check-content {
        flex-direction: row;
        row-gap: 0;
        justify-content: flex-start;
        align-items: flex-start;
        column-gap: $grid-gutter-width;
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .magazine-check-header {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        column-gap: $grid-gutter-width;
    }

    .magazine-check-header {
        .actions {
            width: auto;
            margin-left: auto;
        }
    }
}

.page-label {
    background-color: #07a1ff;
    color: #fff;
    width: 30px;
    height: 30px;
    position: absolute;
    text-align: center;
    font-size: 12px;
    padding-top: 5px;
}
.images {
    clear: both;
}

.images .left {
    float: left;
}

.images .right {
    float: right;
}

.images img {
    width: calc(50% - 5px);
    border: 1px solid #000;
}
</style>
